var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"web-conference-recording"},[(_vm.isSession)?_c('session-wrapper'):_vm._e(),(_vm.isMeetings)?_c('meeting-live',{attrs:{"meeting-id":_vm.id}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }